import { useEffect } from 'react'
import { actions, history } from '@sparky/framework'
import { VIEW_MANAGE_SUBSCRIPTION, VIEW_MANAGE_TENANT } from '../../../common/constants/GlobalConstants'

const SubscriptionFlowCheck = () => {
  useEffect(() => {
    if (history?.location.pathname.includes(VIEW_MANAGE_TENANT)) {
      actions.openCommonModule(VIEW_MANAGE_TENANT)
    }
    else {
      actions.openCommonModule(VIEW_MANAGE_SUBSCRIPTION)
    }
  }, [])

  return null
}
export default SubscriptionFlowCheck
